import styled from "styled-components";

export const Text = styled.p`
color: white;
font-size: 16px
`

export const Tytle = styled.h1`
color: white;
`

export const RedText = styled.p`
color: red;
font-size: 20px
`

export const RedTytle = styled.h1`
color: red;
`

export const Button = styled.button`
color: white;
  background-color: red;
outline: none;
`

export const Logo = styled.img`
width: 50px;
height: 50px
`

